<script lang="ts" setup>
import type { EditorialFashionShow } from '@integration-layer/ampliance/schemas/editorial-fashion-show-schema.localized'
import type {
  EditorialFashionShowProps,
  FashionShowCard,
} from '@design-system/components/Editorial/FashionShow/EditorialFashionShow.props'
import type { UILinkProps } from '@design-system/components/UI/Link/UILink.props'
import type {
  UIMediaProps,
  Image,
  Video,
} from '@design-system/components/UI/UIMedia.props'
const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialFashionShow
}>()

const data = await useComponentResponse<EditorialFashionShow>(props)

const mapMedia = (rawMedia: UIMediaProps) => {
  if (!rawMedia || !rawMedia.media) {
    throw new Error('Invalid media data provided')
  }
  if (rawMedia.media.type === 'image') {
    return {
      media: {
        type: 'image',
        srcImage: {
          secure_url: rawMedia.media.srcImage.secure_url,
          public_id: rawMedia.media.srcImage.public_id,
        },
        alt: rawMedia.media.alt,
        sizes: rawMedia.media.sizes,
      } as Image,
    }
  } else if (rawMedia.media.type === 'video') {
    return {
      media: {
        type: 'video',
        srcVideo: {
          secure_url: rawMedia.media.srcVideo.secure_url,
          public_id: rawMedia.media.srcVideo.public_id,
        },
        autoplay: rawMedia.media.autoplay,
        muted: rawMedia.media.muted,
        showCommands: rawMedia.media.showCommands,
        commandsColor: rawMedia.media.commandsColor,
        commandsPosition: rawMedia.media.commandsPosition,
        coverImage: rawMedia.media.coverImage,
        subtitle: rawMedia.media.subtitle,
        quality: rawMedia.media.quality,
      } as Video,
    }
  }
  throw new Error('Unsupported media type')
}

const cards: FashionShowCard[] = (data.value?.cards ?? []).map((card: any) => ({
  link: card.link
    ? ([
        {
          target: card.link[0].target,
          type: card.link[0].type,
          label: card.link[0].label,
          backgroundColor: card.link[0].backgroundColor,
          labelColor: card.link[0].labelColor,
          ariaLabel: card.link[0].ariaLabel,
        },
      ] as UILinkProps[])
    : undefined,
  media: mapMedia(card.media),
  aspectRatio: card.aspectRatio || '4/5',
}))

const mappedData: EditorialFashionShowProps = {
  defaultView: data.value?.defaultView ?? 'carousel',
  gridColumn: {
    tablet: data.value?.gridColumn ? (data.value?.gridColumn.tablet ?? 5) : 5,
    desktop: data.value?.gridColumn ? (data.value?.gridColumn.desktop ?? 6) : 6,
  },
  showChangeView: data.value?.showChangeView ?? true,
  title: data.value?.title ?? undefined,
  cards: cards,
}
</script>

<template>
  <div>
    <EditorialFashionShow v-bind="mappedData" />
  </div>
</template>
